module.exports = __webpack_public_path__ + "static/media/carousel-img03.e02c6ff9.png";